import { registerModule } from "../module.register";
import { accountingRoutes } from "./accounting.routes";

registerModule(() => ({
  name: "accounting",
  routes: accountingRoutes,
  dependencies: ["auth"],
}));
